import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, EventEmitter, Inject, Input, AfterViewInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { timer } from 'rxjs';
import { loadLazyJsFile } from '../util';

/**
 * https://developers.google.com/classroom/guides/sharebutton#explicit-load
 */
@Directive({
  selector: '[tmShareGoogleClassroom]'
})
export class ShareGoogleClassroomDirective implements AfterViewInit {
  /** 插件初始化完成後觸發 */
  static pulginInit = new EventEmitter<void>();
  /** 全域的插件初始化完成 */
  static isPluginInit = false;
  /** 全域的插件在正初始化中 */
  static isPluginIniting = false;
  /** 載入插件的方法 */
  static loadPlugin(renderer: Renderer2, parentEl: Element) {
    ShareGoogleClassroomDirective.isPluginIniting = true;
    window['___gcfg'] = {
      parsetags: 'explicit'
    };
    loadLazyJsFile(renderer, 'googleApiPlatform', 'https://apis.google.com/js/platform.js', true);
    checkPluginCanUse(() => {
      ShareGoogleClassroomDirective.isPluginInit = true;
      ShareGoogleClassroomDirective.isPluginIniting = false;
      ShareGoogleClassroomDirective.pulginInit.emit();
      ShareGoogleClassroomDirective.pulginInit.complete();
    });
  }
  /** 是否渲染端為瀏覽器 */ // tslint:disable-next-line: member-ordering
  protected isBrowser: boolean;
  /** 是否可以開始使用元件了 */ // tslint:disable-next-line: member-ordering
  canInit = false;
  /** 要分享到 google classroom 的網址 */ // tslint:disable-next-line: member-ordering
  @Input('tmShareGoogleClassroom') config: { url: string; size?: number; title?: string; };

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private el: ElementRef,
    private render: Renderer2,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngAfterViewInit() {
    if (this.isBrowser) {
      if (!ShareGoogleClassroomDirective.isPluginInit && !ShareGoogleClassroomDirective.isPluginIniting) {
        if (isPluginLoaded()) {
          ShareGoogleClassroomDirective.isPluginInit = true;
        } else {
          ShareGoogleClassroomDirective.loadPlugin(this.render, this.el.nativeElement);
        }
      }

      if (!ShareGoogleClassroomDirective.isPluginInit) {
        ShareGoogleClassroomDirective.pulginInit.subscribe(() => {
          this.init();
          this.canInit = true;
        });
      } else {
        this.init();
        this.canInit = true;
      }
    }
  }

  init() {
    gapi['sharetoclassroom'].render(this.el.nativeElement, this.config );
    const ckIframeTmSubc = timer(0, 150).subscribe(t => {
      const iframe = document.body.querySelector('iframe[name^=oauth2relay]');
      if (iframe) {
        ckIframeTmSubc.unsubscribe();
        iframe.setAttribute('title', 'Google classroom api 附帶的 oauth2 功能');
      }
    });
  }

}

function isPluginLoaded() {
  return window['gapi'] && window['gapi']['sharetoclassroom'];
}

const checkPluginCanUse = (cb: () => void) => {
  const cpTmSubc = timer(0, 150).subscribe(t => {
    if (isPluginLoaded()) {
      cpTmSubc.unsubscribe();
      cb();
    }
  });
};
